import Client from './client'

export default class Store {
    constructor(ref) {
        this.client = new Client()
        this.ref = ref
    }

    async update(uuid, data, opts = {}) {
        let { source = 'platform' } = opts

        return await this.client.http().post(`/v3/system/component/${this.ref}/model/${uuid}`, data, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async create(data, opts = {}) {
        let { source = 'platform' } = opts

        return await this.client.http().post(`/v3/system/component/${this.ref}/model`, data, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async delete(uuid, opts = {}) {
        let { source = 'platform' } = opts

        return await this.client.http().delete(`/v3/system/component/${this.ref}/model/${uuid}`, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async getModelByUUID(uuid, opts = {}) {
        let { source = 'platform' } = opts
        
        return await this.client.http().get(`/v3/system/component/${this.ref}/model/${uuid}`, {
            headers: {
                'X-Source': source,
            }
        })
    }

    async models(params, options) {
        return await this.client.http().get(`/v3/system/component/${this.ref}/models`, {
            params: params,
            headers: {
                'X-App': options.app,
                'X-Cache': options.cache || false,
                'X-Build-Ttl': options.buildTTL || -1,
                'X-Source': options.source || 'platform'
            }
        })
    }
}